import { LightCarouselSettings, Slide } from './types'

export const DEFAULT_PROPS: {
  slides: Slide[]
} & LightCarouselSettings = {
  slides: [],
  timePerSlide: 2_000,
  transitionEasing: 'easeLinear',
  transitionDuration: 500,
  autoScroll: true,
  imageShape: 'circle',
}
